// extracted by mini-css-extract-plugin
module.exports = {"formItem":"IntroSurveyModal_formItem_3GYUZ"};